export default __webpack_public_path__ + "static/media/item-list-review.86caa458.svg";